import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { Routes, RouterModule } from "@angular/router";
import { AppRoutingModule } from "./app.routing.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { DatePipe } from "@angular/common";

import { NgApexchartsModule } from "ng-apexcharts";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SortDirective } from "./_directives/sortable.directive";
import { DragDropModule } from "@angular/cdk/drag-drop";

//import { Ng2SearchPipeModule } from 'ng2-search-filter';

import { AppComponent } from "./app.component";
import { NavbarComponent } from "./_layout/theme/navbar/navbar.component";
import { SidebarComponent } from "./_layout/theme/sidebar/sidebar.component";
import { SelectLanguageComponent } from "./_pages/account/select-language/select-language.component";
import { VendorMasterDataComponent } from "./_pages/account/vendor-master-data/vendor-master-data.component";
import { GetStartedComponent } from "./_pages/account/get-started/get-started.component";
import { SupplierHomeComponent } from "./_pages/supplier/supplier-home/supplier-home.component";
import { PurchaseOrdersComponent } from "./_pages/supplier/purchase-orders/purchase-orders.component";
import { SupplierChangePasswordComponent } from "./_pages/account/supplier-change-password/supplier-change-password.component";
import { ProofOfDeliveryComponent } from "./_pages/supplier/proof-of-delivery/proof-of-delivery.component";
import { InvoicesComponent } from "./_pages/supplier/invoices/invoices.component";
import { InvoiceSubmissionComponent } from "./_pages/supplier/invoice-submission/invoice-submission.component";
import { UploadPreviewComponent } from "./_pages/supplier/upload-preview/upload-preview.component";
import { SignInComponent } from "./_pages/account/sign-in/sign-in.component";
import { LoadersComponent } from "./_shared/ui/loaders/loaders.component";
import { ResetPasswordComponent } from "./_pages/account/reset-password/reset-password.component";
import { ResetPasswordLangingPageComponent } from "./_pages/account/reset-password-langing-page/reset-password-langing-page.component";
import { VendorProfileComponent } from "./_pages/supplier/vendor-profile/vendor-profile.component";
import { CreditNotesComponent } from "./_pages/supplier/credit-note/credit-notes/credit-notes.component";
import { CreditNoteUploadPreviewComponent } from "./_pages/supplier/credit-note/credit-notes/credit-note-upload-preview/credit-note-upload-preview.component";
import { UploadCreditNoteComponent } from "./_pages/supplier/credit-note/credit-notes/upload-credit-note/upload-credit-note.component";
import { UploadNonpoCreditNoteComponent } from "./_pages/supplier/credit-note/credit-notes/upload-nonpo-credit-note/upload-nonpo-credit-note.component";
import { SubmitNonpoInvoiceComponent } from "./_pages/supplier/submit-nonpo-invoice/submit-nonpo-invoice.component";
import { InvoiceDetailComponent } from "./_pages/supplier/invoice-detail/invoice-detail.component";
import { ProofOfDeliveryServiceComponent } from "./_pages/supplier/proof-of-delivery-service/proof-of-delivery-service.component";
import { PoDetailsComponent } from "./_pages/supplier/po-details/po-details.component";
import { UploadPreviewNonpoComponent } from "./_pages/supplier/upload-preview-nonpo/upload-preview-nonpo.component";
import { UploadPreviewDigitalInvoiceComponent } from "./_pages/supplier/upload-preview-digital-invoice/upload-preview-digital-invoice.component";
import { UploadPreviewNonpoDigitalInvoiceComponent } from "./_pages/supplier/upload-preview-nonpo-digital-invoice/upload-preview-nonpo-digital-invoice.component";
import { ViewGrnComponent } from "./_pages/supplier/view-grn/view-grn.component";
import { LoaderComponent } from "./_shared/loader/loader.component";
import { ChangePasswordComponent } from "./_pages/supplier/change-password/change-password.component";
import { SubmitLogisticsComponent } from "./_pages/supplier/submit-logistics/submit-logistics.component";
import { UploadPreviewLogisticsComponent } from "./_pages/supplier/upload-preview-logistics/upload-preview-logistics.component";
import { UploadPreviewLogisticsDigitalInvoiceComponent } from "./_pages/supplier/upload-preview-logistics-digital-invoice/upload-preview-logistics-digital-invoice.component";
import { SavedInvoicesComponent } from "./_pages/supplier/saved-invoices/saved-invoices.component";
import { SavedInvoicesNonpoComponent } from "./_pages/supplier/saved-invoices-nonpo/saved-invoices-nonpo.component";
import { SavedInvoicesPosComponent } from "./_pages/supplier/saved-invoices-pos/saved-invoices-pos.component";
import { BuyerAnalyticsComponent } from "./_pages/buyers/buyer-analytics/buyer-analytics.component";
import { SearchFilterPipe } from "./_pipes/search-filter.pipe";
import { InrdisplayPipe } from "./_app-core/pipes/inrdisplay.pipe";
import { OrderByPipe } from "./_app-core/pipes/order-by.pipe";
import { DragNDropDirective } from "./_directives/drag-n-drop.directive";

@NgModule({
    declarations: [
        AppComponent,
        NavbarComponent,
        SidebarComponent,
        LoaderComponent,
        SelectLanguageComponent,
        VendorMasterDataComponent,
        GetStartedComponent,
        SupplierHomeComponent,
        SupplierChangePasswordComponent,
        PurchaseOrdersComponent,
        InvoicesComponent,
        ProofOfDeliveryComponent,
        InvoiceSubmissionComponent,
        UploadPreviewComponent,
        UploadPreviewDigitalInvoiceComponent,
        UploadPreviewNonpoDigitalInvoiceComponent,
        SignInComponent,
        ResetPasswordComponent,
        LoadersComponent,
        ResetPasswordLangingPageComponent,
        VendorProfileComponent,
        CreditNotesComponent,
        CreditNoteUploadPreviewComponent,
        UploadCreditNoteComponent,
        UploadNonpoCreditNoteComponent,
        SubmitNonpoInvoiceComponent,
        InvoiceDetailComponent,
        ProofOfDeliveryServiceComponent,
        PoDetailsComponent,
        UploadPreviewNonpoComponent,
        ChangePasswordComponent,
        SavedInvoicesComponent,
        SavedInvoicesPosComponent,
        ViewGrnComponent,
        SavedInvoicesNonpoComponent,
        UploadPreviewLogisticsComponent,
        UploadPreviewLogisticsDigitalInvoiceComponent,
        SubmitLogisticsComponent,
        BuyerAnalyticsComponent,
        SearchFilterPipe,
        InrdisplayPipe,
        OrderByPipe,
        SortDirective,
        DragNDropDirective,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        NgbModule,
        NgApexchartsModule,
        RouterModule,
        NgxExtendedPdfViewerModule,
        ReactiveFormsModule,
        FormsModule,
        HttpClientModule,
        DragDropModule,
        //PdfViewerModule,
        // Ng2SearchPipeModule,
    ],
    providers: [ DatePipe ],
    entryComponents: [SupplierHomeComponent],
    bootstrap: [AppComponent],
})
export class AppModule {}
